// extracted by mini-css-extract-plugin
export default {"list":"app-edit-list_list__EA-2X","buttons":"app-edit-list_buttons__RjYqX","empty":"app-edit-list_empty__x8vgm"};